import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import SmartWorkTrackerServices from "./SmartWorkTrackerServices";
import { useTranslation } from "react-i18next";

interface SmartWorkTrackerServicesDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SmartWorkTrackerServicesDialog: React.FC<SmartWorkTrackerServicesDialogProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation();
  
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            onClick={onClose}
          />
          
          {/* Dialog */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="fixed inset-4 z-50 overflow-hidden"
          >
            <div className="h-full bg-white rounded-xl shadow-xl flex flex-col">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">
                  {t("smartWorkTrackerServicesDialog.title")}
                </h2>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <X className="h-6 w-6 text-gray-500" />
                </button>
              </div>
              
              {/* Content */}
              <div className="flex-1 overflow-y-auto p-6">
                <SmartWorkTrackerServices />
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SmartWorkTrackerServicesDialog;
